const en_mitra_list = {
    "": "Daftar Mitra",

}

export default en_mitra_list;